import { Component, OnInit, ViewChild } from '@angular/core';

//app

import { UserRole } from 'base-models';

import { EditBaseComponent } from '@solar/shared/edit-base.component';
import { Site, Company } from 'solar-bo';
import { FormBuilder } from '@angular/forms';

import { VerifierSitesListComponent } from './verifier-sites-list.component';
import { VerifierService } from './verifier.service';
import { mergeMap, map, catchError, tap } from 'rxjs/operators';
import { VerifierRoles } from 'solar-bo';;


@Component({
  selector: 'app-verifier-detail',
  templateUrl: './verifier-detail.component.html',
  styleUrls: ['./verifier-detail.component.scss']
})
export class VerifierDetailComponent extends EditBaseComponent implements OnInit {

  company_external: Company;
  /**
   * roles for external company
   */
  roles: UserRole[] = VerifierRoles.roles;
  @ViewChild('sitesAsigned') sitesAsignedComponent: VerifierSitesListComponent;

  constructor(
    private baseService: VerifierService
    , private fb: FormBuilder
  ) {
    super();
    this.createForm();
  }

  ngOnInit() {
    this.getViewModel();

  }

  createForm() {
    this.myform = this.fb.group({
      profile: [[]],
    }
    );
  }

  getViewModel() {
    let req = this.baseService.getVerifierCompanies();

    //let filterSitesForVerifier = `filter={\"columns\":[\"id\",\"name\",\"company_acl\"]}`;
    let filterSitesForVerifier = `filter={\"columns\":[\"id\",\"company_site.id_company\",\"company_site.info as company_acl\",\"name\"]}`;
    let defaultVerifier = null;
    req.pipe(
      tap(companyList => defaultVerifier = companyList[0]),
      mergeMap(companyList =>
        this.baseService.companySitesGetAll(defaultVerifier, filterSitesForVerifier)
          .pipe(
            map(companysites => {
              let verifier = new Company();
              let firstItemAsCompany = companyList[0];
              verifier.id = firstItemAsCompany.id;
              verifier.name = firstItemAsCompany.name;
              verifier.sites = companysites;
              return verifier;
            })
          )
      ))
      .subscribe(resmodel => this.getViewModelHandleResult(resmodel)
        , err => this.handleError(err));
  }


  setVerifierCompany(res) {
    //this.company_external=res[0];
  }

  getViewModelHandleResult(resmodel: any) {
    this.loading = false;
    this.company_external = resmodel;
    console.log("Verifier DetailComponent getViewModel handleresult :", resmodel);
  }

  isvalid() {
    /*     if (this.editform!=null){//en el inicio no es accesible
          return this.editform.isvalid();
        }
        else{
          return false;
        } */

    return true;

  }

  saveModel() {
    try {


      this.alertmessage = null;
      let model: Company = this.company_external;
      let sitesToAsign = [];
      let asign: any[] = this.sitesAsignedComponent.selectionGetSelected();
      for (let as of asign) {
        let sitepermissions = as;
        let perm = [];
        if (sitepermissions.read) {
          perm.push(this.profileEnum.SITE_READ);
        }
        if (sitepermissions.edit) {
          perm.push(this.profileEnum.SITE_EDIT);
        }
        let obj = { id_site: sitepermissions.id_site, info: { access_level: perm } };
        sitesToAsign.push(obj);
      }

      console.log(sitesToAsign);
      this.baseService.companyVerifierAddSite(this.company_external.id, sitesToAsign)
        .subscribe(() => this.handleSuccesLoad("Sites assigned"), err => this.handleError(err)
        );
      //this.editform.saveModel(this);
    }
    catch (err) {
      this.showNotificationError("Error saving data. ", err);
    }
  }
}
